// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-footnote-container_root__acDfU"};